import PaymentPlanContent from "./PaymentPlanContent.vue"
import PaymentPlanCost from "./PaymentPlanCost.vue"
import PaymentPlanDescription from "./PaymentPlanDescription.vue"
import PaymentPlanEstimator from "./PaymentPlanEstimator.vue"
import PaymentPlansHeader from "./PaymentPlansHeader.vue"
import PaymentPlanImage from "./PaymentPlanImage.vue"
import PaymentPlanOption from "./PaymentPlanOption.vue"
import PaymentPlanOptions from "./PaymentPlanOptions.vue"
import PaymentPlanMonthlyPayment from "./PaymentPlanMonthlyPayment.vue"
import PaymentPlanDownPaymentTable from "./PaymentPlanDownPaymentTable.vue"

export default {
    install(Vue) {
        Vue.component("PaymentPlanContent", PaymentPlanContent)
        Vue.component("PaymentPlanCost", PaymentPlanCost)
        Vue.component("PaymentPlanDescription", PaymentPlanDescription)
        Vue.component("PaymentPlanEstimator", PaymentPlanEstimator)
        Vue.component("PaymentPlanImage", PaymentPlanImage)
        Vue.component("PaymentPlanOption", PaymentPlanOption)
        Vue.component("PaymentPlanOptions", PaymentPlanOptions)
        Vue.component("PaymentPlanMonthlyPayment", PaymentPlanMonthlyPayment)
        Vue.component("PaymentPlanDownPaymentTable", PaymentPlanDownPaymentTable)
        Vue.component("PaymentPlansHeader", PaymentPlansHeader)
    },
}
